import { render } from "./evento.vue?vue&type=template&id=c867971e&scoped=true"
import script from "./evento.vue?vue&type=script&lang=js"
export * from "./evento.vue?vue&type=script&lang=js"

import "./evento.vue?vue&type=style&index=0&id=c867971e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c867971e"]])

export default __exports__